import { combineReducers } from 'redux';
import onlineCourse from './modules/courses/reducer';
import participant from './modules/participants/reducer';

export default combineReducers({
  onlineCourse,
  participant,
});
